import { REACT_APP_API_URL } from "../../setup/config";
import axios, { handleApiError } from '../axios';

export const getBuyerWishList = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-wish-list/`, data);
        return await response.data;
    } catch (error) {
        console.log("getBuyerWishList - error", error)
        return handleApiError(error)
    }
}


export const getBuyerWishListById = async (buyerWishListId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/buyer-wish-list/${buyerWishListId}`);
        return await response.data;
    } catch (error) {
        console.log("getBuyerWishListById - error", error)
        return handleApiError(error)
    }
}

export const insertBuyerWishList = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/buyer-wish-list/create`, data);
        return await response.data;
    } catch (error) {
        console.log("insertBuyerWishList - error", error)
        return handleApiError(error)
    }
}

export const updateBuyerWishList = async (data) => {
    try {
        const response = await axios.put(`${REACT_APP_API_URL}/buyer-wish-list/update`, data);
        return await response.data;
    } catch (error) {
        console.log("updateBuyerWishList - error", error)
        return handleApiError(error)
    }
}